import React from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';
import './NotificationToast.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

interface NotificationToastProps {
    show: boolean;
    onClose: () => void;
    message: string;
    variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark';
    delay?: number;
}

const NotificationToast: React.FC<NotificationToastProps> = ({
    show,
    onClose,
    message,
    variant = 'primary',
    delay = 3000,
}) => {

    const getToastColorClass = (variant: string) => {
        switch (variant) {
            case 'success':
                return 'toast-success';
            case 'danger':
                return 'toast-danger';
            case 'warning':
                return 'toast-warning';
            case 'info':
                return 'toast-info';
            case 'primary':
                return 'toast-primary';
            case 'dark':
                return 'toast-dark';
            case 'light':
                return 'toast-light';
            default:
                return 'toast-primary';
        }
    };

    return (
        <ToastContainer
            className={`p-3 notification-toast ${getToastColorClass(variant)}`}
        >
            <Toast onClose={onClose} show={show} autohide delay={delay} bg={variant}>
                <Toast.Body className="text-white"><span className="me-2"><FontAwesomeIcon icon={faCheckCircle} /></span> {message}</Toast.Body>
            </Toast>
        </ToastContainer>
    );
};

export default NotificationToast;
